import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { CustomerUser } from '@ansvar-sakerhet/api-client';
import { S } from '../AddCustomerUserModal/AddCustomerUserModal.style';
import { EditCustomerUserForm } from '../EditCustomerUserForm/EditCustomerUserForm';

type Props = {
  user: CustomerUser | null;
  clientId: string;
  open: boolean;
  onCancel: () => void;
};

export const EditCustomerUserModal: React.FC<Props> = (props) => {
  if (!props.open || !props.user) {
    return null;
  }

  return (
    <Dialog.Root open={props.open}>
      <Dialog.Portal>
        <S.Overlay>
          <S.Content>
            <S.ContentHeader>
              <Dialog.Title asChild>
                <S.H4>Redigera kund-användare</S.H4>
              </Dialog.Title>

              <S.CloseButton asChild onClick={props.onCancel}>
                <S.Icon src="Close" width={20} height={20} />
              </S.CloseButton>
            </S.ContentHeader>

            <EditCustomerUserForm
              user={props.user}
              clientId={props.clientId}
              onCancel={props.onCancel}
            />
          </S.Content>
        </S.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
